import { render, staticRenderFns } from "./BaseMessageThread.vue?vue&type=template&id=585e6190"
import script from "./BaseMessageThread.vue?vue&type=script&lang=js"
export * from "./BaseMessageThread.vue?vue&type=script&lang=js"
import style0 from "./BaseMessageThread.vue?vue&type=style&index=0&id=585e6190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports